import styled from "styled-components";
import React, { FC, HTMLAttributes } from "react";

const BannerArea: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return <Root {...props}>{React.Children.map(children, (child) => child && <Row>{child}</Row>)}</Root>;
};
export default React.memo(BannerArea);

const Root = styled.div`
  max-width: 420px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Row = styled.div`
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;
